<template>
  <HealthButtonCollection
    :id="id"
    v-bind="elem.attributes"
  />
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import HealthButtonCollection from './HealthButtonCollection.vue';

  export default defineNuxtComponent({
    name: 'HealthButtonCollectionBlock',

    components: {
      HealthButtonCollection,
    },

    props: {
      elem: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },

    setup() {
      return { id: useId() };
    },
  });
</script>
